const defaultPermissions = {
  canViewAccountsContacts: ['Self'],
  canEditAccountsContacts: ['Self'],
  canExportAccountsContactsCSV: true,
  canBulkImportContactsCSV: true,
  canUseEnrichment: true,
  canAddSignals: true,
  canGenerateHyperpersonalizedMessages: true,
  canViewOtherPeopleList: false,
  canEditOtherPeopleList: false,
  canAccessWebsiteReveal_module: true,
  canQualifyAccountsFromWebsite: true,
  canExportCsvFromWebsite: true,
  canRecategorizeWebpages: true,
  canAccessDatabaseSearch_module: true,
  canQualifyAccounts: true,
  canQualifyContacts: true,
  canAddToList: true,
  canAccessSettings_module: true,
  canSetupIntegrations: ['No access'],
  canSetupIcp: ['No access'],
  canSetupIntentTopics: ['No access'],
  canSetupAgents: ['No access'],
  canSetupCustomFields: ['No access'],
  canSetupWebsiteTracking: ['No access'],
  canSetupUsers: ['No access'],
  canSetupRolesAndPermissions: ['No access'],
  canSetupMillerHeimanRoles: ['No access'],
  canSetupHPMConfig: ['No access'],
  canAssignCredits: true,
};

export const SET_ROLE_PERMISSIONS = 'SET_ROLE_PERMISSIONS';
export const setRolePermissions = (payload: Record<string, string[] | boolean>) => ({
  type: SET_ROLE_PERMISSIONS,
  payload: payload,
});

interface Action {
  type: string;
  payload: Record<string, string[] | boolean>;
}

const initialState: Record<string, string[] | boolean> = { ...defaultPermissions };

/* Reducers */
const rolePermissionsReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_ROLE_PERMISSIONS:
      return { ...action.payload };

    default:
      return state;
  }
};

export default rolePermissionsReducer;
